import { colors, radius, s8 } from '@ardoq/design-tokens';
import { styled } from 'styled-components';

type AdvancedNavMenuProps = {
  children: React.ReactNode;
  /**
   * You can set menuId and pass it as "aria-owns" to any menuitem that is not a descendant of a menu element in the DOM.
   * This way we can to define the relationship between the menu and the menuitem.
   * This is useful for accessibility purposes.
   */
  menuId?: string;
  /**
   * The menu is required to have an accessible name.
   * Use aria-labelledby if a visible label is present.
   * Set the aria-labelledby to the id to the menuitem or button that controls its display.
   */
  ariaLabelledBy?: string;
  /**
   * The menu is required to have an accessible name.
   * Use ariaLabel if no visible label is not present.
   */
  ariaLabel?: string;
};

export const AdvancedNavigationMenu = ({
  children,
  menuId,
  ariaLabelledBy,
  ariaLabel,
}: AdvancedNavMenuProps) => {
  return (
    <nav>
      <MenuWrapper
        id={menuId}
        role="menu"
        aria-labelledby={ariaLabelledBy}
        aria-label={ariaLabel}
      >
        {children}
      </MenuWrapper>
    </nav>
  );
};

const MenuWrapper = styled.ul`
  border: 1px solid ${colors.borderAction};
  border-radius: ${radius.r16};
  list-style-type: none;
  margin: 0;
  padding: ${s8};
  display: flex;
  flex-direction: column;
`;
